import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ErrorProvider } from './context/ErrorContext';

import './assets/scss/_global.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AuthProvider>
            <ErrorProvider>
                <App />
            </ErrorProvider>
        </AuthProvider>
    </React.StrictMode>
);